import createAdaptiveCardsConfig from 'botframework-webchat/lib/adaptiveCards/Styles/adaptiveCardHostConfig';
import { StyleOptions as WebChatStyleOptions } from 'botframework-webchat';
import { StyleOptions as BFFStyleOptions } from '@sa/bff-webchat-ui';

const DEFAULT_ACCENT = '#E0E0E0';

export function buildFontFamily(fonts: string[]) {
  return fonts
    .map(function (font) {
      // tslint:disable-next-line:quotemark
      return "'".concat(font, "'");
    })
    .join(', ');
}

// For more info about how adaptive cards host config format and how it fits into botframework:
// https://docs.microsoft.com/en-us/adaptive-cards/rendering-cards/host-config
// https://github.com/microsoft/BotFramework-WebChat/issues/2034#issuecomment-501818238
// https://bisser.io/bot-framework-v4-webchat-styling-options/
// These properties follow that format
const primaryFont = buildFontFamily(['Open Sans', 'Arial', 'Calibri', 'Helvetica Neue', 'sans-serif']);

const fontSizes = {
  small: 10,
  default: 16,
  medium: 16,
  large: 18,
  extraLarge: 22
};

const fontWeights = {
  lighter: 200,
  default: 400,
  bolder: 600
};

export const bffStyleOptions: BFFStyleOptions = {
  loadingColor: '#1e5399',
  primaryFont
};

export const webChatStyleOptions: WebChatStyleOptions = {
  accent: DEFAULT_ACCENT,
  backgroundColor: '#E4E4E4',

  autoScrollSnapOnPage: true,

  // Bot Bubble
  bubbleBackground: '#FFFFFF',
  bubbleTextColor: '#000000',
  bubbleBorderRadius: 8,
  bubbleNubSize: 11,
  bubbleNubOffset: 6,

  // User Bubble
  bubbleFromUserBackground: '#1e5399',
  bubbleFromUserTextColor: '#FFFFFF',
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserNubSize: 11,
  bubbleFromUserNubOffset: 6,
  // Suggested actions
  suggestedActionBorderColor: '#1e5399', // defaults to accent
  suggestedActionBorderRadius: 6,
  suggestedActionBorderStyle: 'solid',
  suggestedActionBorderWidth: 0,
  suggestedActionBackgroundColor: '#1e5399',
  suggestedActionTextColor: 'white',
  //suggestedActionLayout: 'stacked', // either "carousel" or "stacked"
  // Other settings
  primaryFont,
  richCardWrapTitle: true,
  hideUploadButton: true, // Bot does not accept files
  //timestampFormat: 'absolute',
  timestampColor: '#666666'
};

// There are no types provided for host config, details can be found here:
// https://docs.microsoft.com/en-us/adaptive-cards/rendering-cards/host-config
export const adaptiveCardsHostConfig: Record<string, any> = createAdaptiveCardsConfig(webChatStyleOptions);
adaptiveCardsHostConfig.fontFamily = primaryFont;
adaptiveCardsHostConfig.fontSizes = fontSizes;
adaptiveCardsHostConfig.fontWeights = fontWeights;
//text colour
adaptiveCardsHostConfig.containerStyles.default.foregroundColors.default.default = webChatStyleOptions.bubbleTextColor;
